// extracted by mini-css-extract-plugin
export default {"container":"CollectionYardsVisitsDetailTable_container__2K3cJ"};